import ClientSDK from '../../App/ClientSDK'
import {AxiosResponse} from 'axios'
import Transformer from './Transformer'
import {IApiCustomer, ICustomer} from '../interfaces/ICustomer'

class Client {
    static search = (keyword: string, withInvoiceInformation: boolean): Promise<ICustomer[]> => {
        const params = new URLSearchParams({keyword, include_invoice_information: withInvoiceInformation ? '1' : '0'});

        return ClientSDK
            .instance()
            .get('customers/search?' + params.toString())
            .then((response: AxiosResponse): ICustomer[] => {
                return response.data.customers.map((data: IApiCustomer) => Transformer.transform(data))
            })
    }
}

export default Client
